import { Address, Hex, getAddress, isHex } from 'viem'
import z from 'zod'
import type { SupportedChainId, SupportedCronChainId } from '../config'
import { isSupportedChainId, isSupportedCronChainId } from '../config'
export const addressSchema = z.custom<Address>().transform((value, ctx) => {
  try {
    return getAddress(value)
  } catch {
    ctx.addIssue({
      code: 'custom',
      message: 'Invalid Ethereum address',
    })
    return z.NEVER
  }
})
export const chainIdSchema = z.preprocess(
  (val) => (typeof val === 'string' ? Number.parseInt(val) : val),
  z.custom<SupportedChainId>((val) => typeof val === 'number' && !Number.isNaN(val) && isSupportedChainId(val), {
    message: 'Unsupported chainId',
  }),
)

export const hexSchema = z.custom<Hex>(isHex, { message: 'Invalid hex' })

export const chainIdCronSchema = z.preprocess(
  (val) => (typeof val === 'string' ? Number.parseInt(val) : val),
  z.custom<SupportedCronChainId>(
    (val) => typeof val === 'number' && !Number.isNaN(val) && isSupportedCronChainId(val),
    {
      message: 'Unsupported chainId',
    },
  ),
)
export const nativeSchema = z.object({
  isNative: z.literal(true),
  name: z.string().optional(),
  symbol: z.string().optional(),
  logoURI: z.string().optional(),
  decimals: z.number(),
  chainId: chainIdSchema.optional(),
  address: addressSchema,
})

export const tokenSchema = z.object({
  isNative: z.literal(false),
  name: z.string().optional(),
  symbol: z.string().optional(),
  logoURI: z.string().optional(),
  decimals: z.number(),
  chainId: chainIdSchema.optional(),
  address: addressSchema,
})

export const amountSchema = z.object({
  amount: z.string(),
  currency: z.discriminatedUnion('isNative', [nativeSchema, tokenSchema]),
})

export const amountSchemaToken = z.object({
  amount: z.string(),
  currency: tokenSchema,
})

export const amountSchemaNative = z.object({
  amount: z.string(),
  currency: nativeSchema,
})

export const blockNumberSchema = z
  .string()
  .refine((val) => !Number.isNaN(Number(val)), {
    message: 'Block number must be a valid number',
  })
  .transform<bigint>((val) => BigInt(val))
  .refine((val) => val > 0n, { message: 'Block number must be greater than 0' })

export const bigIntSchema = z.string().transform<bigint>((val) => BigInt(val))

export const addressesSchema = z
  .string()
  .transform<Address[]>((val) => val.split(',').map((address) => addressSchema.parse(address)))

export type SerializedNative = z.infer<typeof nativeSchema>
export type SerializedToken = z.infer<typeof tokenSchema>
export type SerializedAmount = z.infer<typeof amountSchema>
